import React from 'react';
import HeroSection from '../components/home/HeroSection';
import HomeAbout from '../components/home/HomeAbout';
import HomeContact from '../components/home/HomeContact';
import Articles from './Articles';

const Home = () => {
  return (
    <div>
      <HeroSection />
      <HomeAbout />
      <Articles />
      <HomeContact />
      
    </div>
  );
};

export default Home;
